"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useStateWithCallback = (initialState, defaultCallback) => {
    const [state, setState] = (0, react_1.useState)(initialState);
    const setStateWithCallback = (action, cb = defaultCallback) => {
        setState(action);
        const newState = typeof action === 'function' ? action(state) : action;
        cb && cb(newState);
    };
    return [state, setStateWithCallback];
};
exports.default = useStateWithCallback;
//# sourceMappingURL=useStateWithCallback.js.map